<div class="searchable-select" [class.is-open]="open" [class.is-disabled]="disabled">
  <button
    type="button"
    class="searchable-select__trigger form-select w-full rounded-xl border-gray-200 bg-white text-left dark:border-[#191e3a] dark:bg-[#0e1726]"
    [attr.aria-expanded]="open"
    [disabled]="disabled"
    (click)="toggle()"
  >
    <span class="searchable-select__value" [class.is-placeholder]="!value">
      {{ selectedLabel || placeholder }}
    </span>
    <span class="searchable-select__chevron" aria-hidden="true"></span>
  </button>

  @if (open) {
  <div class="searchable-select__panel" (click)="$event.stopPropagation()" (keydown.escape)="close()">
    <input
      #searchInput
      type="search"
      class="searchable-select__search form-input w-full rounded-lg border-gray-200 bg-white dark:border-[#191e3a] dark:bg-[#0e1726]"
      [(ngModel)]="query"
      [name]="name ? name + '_search' : 'searchable_select_search'"
      placeholder="Search…"
      autocomplete="off"
      (keydown.escape)="close()"
    />
    <ul class="searchable-select__list">
      @if (clearable) {
      <li>
        <button type="button" class="searchable-select__option is-muted" (click)="clear($event)">
          {{ placeholder }}
        </button>
      </li>
      }
      @for (o of filteredOptions; track o.value) {
      <li>
        <button
          type="button"
          class="searchable-select__option"
          [class.is-selected]="o.value === value"
          (click)="select(o)"
        >
          {{ o.label }}
        </button>
      </li>
      } @empty {
      <li class="searchable-select__empty">No matches</li>
      }
    </ul>
  </div>
  }
</div>
